import type { Customer } from '@ztechapps/common.contract'
import { useToggle } from 'react-use'
import { TooltipPopOver } from '@ztechapps/webui.util'
import { UserPopOver } from '../User/UserPopOver'
import { UserCard } from '../User/UserCard'
import type { FunctionComponent } from 'react'
import React from 'react'
import merge from 'lodash/merge'

type Components = {
  userCard: FunctionComponent
  userPopOver: FunctionComponent
}

const defaultComponents = {
  userCard: UserCard,
  userPopOver: UserPopOver,
}

export type MemberWithInfoItemProps = Customer & {
  linkTo?: string
  components?: Components
}

export const MemberWithInfoItem = (props: MemberWithInfoItemProps) => {
  const { profile, tags, remarks, address } = props

  let { components } = props
  components = merge({}, defaultComponents, components)

  const [show, setShow] = useToggle(false)

  return (
    <TooltipPopOver
      trigger="click"
      onToggle={setShow}
      defaultShow={false}
      show={show}
      tooltipHeader="Collaborator Info"
      tooltipBody={<React.Fragment>{components.userPopOver({ address, profile, tags, remarks })}</React.Fragment>}
    >
      <>{components.userCard(props)}</>
    </TooltipPopOver>
  )
}
